const initEmbed = el => {
  // IF iframe
  if (el.dataset.embedIframe) el.setAttribute('src', el.dataset.embedIframe);
};

export { initEmbed };
